module.exports = __webpack_public_path__ + "img/BKLTH.bfa32250.png";